'use strict';

var _components = require('linksoft/core/components');

var _components2 = _interopRequireDefault(_components);

var _addToCart = require('./cart/containers/add-to-cart');

var _addToCart2 = _interopRequireDefault(_addToCart);

var _cart = require('./cart/containers/cart');

var _cart2 = _interopRequireDefault(_cart);

var _cartDetail = require('./cart/containers/cart-detail');

var _cartDetail2 = _interopRequireDefault(_cartDetail);

var _facets = require('./facets/containers/facets');

var _facets2 = _interopRequireDefault(_facets);

var _recaptcha = require('./recaptcha/recaptcha');

var _recaptcha2 = _interopRequireDefault(_recaptcha);

var _captchaRating = require('./recaptcha/captchaRating');

var _captchaRating2 = _interopRequireDefault(_captchaRating);

var _SearchControl = require('./modules/SearchControl');

var _SearchControl2 = _interopRequireDefault(_SearchControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_components2.default.set({
    AddToCart: _addToCart2.default,
    Cart: _cart2.default,
    CartDetail: _cartDetail2.default,
    Facets: _facets2.default,
    Recaptcha: _recaptcha2.default,
    CaptchaRating: _captchaRating2.default,
    SearchControl: _SearchControl2.default
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/components.js
// module id = 1042
// module chunks = 0